/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.programs.modals.confirmSuspendedEventOrder.controllers', [])

.controller('ProgramsModalsConfirmSuspendedEventOrderController', ['$scope', '$uibModalInstance', 'suspendedMessage', function($scope, $uibModalInstance, suspendedMessage) {

    $scope.programsModalsConfirmSuspendedEventOrder = {

      model: "You are editing an order for a suspended event, are you sure you want to continue?",

      init: function() {
        this.model = suspendedMessage;
      },

      cancel: function() {
        $uibModalInstance.dismiss('cancel');
      },

      done: function() {
        $uibModalInstance.close(this.model);
      }

    };

    $scope.programsModalsConfirmSuspendedEventOrder.init();

}]);
